// extracted by mini-css-extract-plugin
export default {"SanitizedHtml":"sanitized-group-header-text-module__SanitizedHtml__JqvOZf6"};